import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import M from 'materialize-css';

const SelectCountry = forwardRef((props, ref) => {
  const { changeCountry } = props;
  const [country, setCountry] = useState('');

  useEffect(() => {
    M.AutoInit();
  }, []);

  useEffect(() => {
    let elems = document.querySelector('#selectCountry');
    M.FormSelect.init(elems);
  }, [country]);

  const updateCountry = (country) => {
    setCountry(country);
    if (changeCountry) {
      changeCountry(country);
    }
  };

  useImperativeHandle(ref, () => ({
    updateCountry: updateCountry,
  }));

  return (
    <div>
      <select
        id="selectCountry"
        className="icons"
        value={country}
        onChange={(e) => {
          updateCountry(e.target.value);
        }}>
        <option value="" disabled>
          Select your Country
        </option>
        <option data-icon="images/ca.svg" value="CA">
          Canada
        </option>
        <option data-icon="images/us.svg" value="US">
          United States
        </option>
        <option data-icon="images/bo.svg" value="BO">
          Bolivia
        </option>
      </select>
      <label>Country</label>
    </div>
  );
});

export default SelectCountry;
